import React, { useState, useRef, useEffect } from "react"
import {
  Col,
  Row,
  Form,
  Container,
  Tab,
  Tabs,
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap"
import Select from "react-select"
import { Navigate, useParams } from "react-router-dom"
import toast, { Toaster } from "react-hot-toast"
import {
  isAdmin,
  selectDropdownStyle,
  toastStyle,
} from "../../Helpers/Utils/Common"
import FileExceedModal from "../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../Assets/Images/no-data-img.png"
import Modal from "antd/es/modal/Modal"
import Upload from "antd/es/upload/Upload"

//components
import Table from "../../Components/TableTemplate/Table"
import ManageTableWithDynamicPagination from "../../Components/TableTemplate/ManageTableWithDynamicPagination"
import Navbar from "../../Components/Navbar/Navbar"
import DeleteModal from "../../Components/Modals/DeleteModal"
import AddModal from "../../Components/Modals/AddModal"
import ViewModal from "../../Components/Modals/ViewModal"
import EditModal from "../../Components/Modals/EditModal"
import InputError from "../../Components/InputError/InputError"
import upload from "../../Assets/Images/upload.png"
import trash from "./../../Assets/Images/trash.png"

//css
import "./Manage.css"
import "../../Components/Navbar/Navbar.css"

//api
import {
  createUser,
  getAllUsers,
  getSingleUser,
  editUser,
  deleteUser,
  searchUser,
} from "../../Helpers/apiCalls/usersApi"
import { refreshPage } from "../../Helpers/Utils/Common"
import { validateUsers } from "../../Helpers/Validation/Manage/UsersValidation"
import {
  getAllEmployees,
  createEmployee,
  getEmployee,
  deleteEmployee,
  searchEmployee,
  updateEmployee,
} from "../../Helpers/apiCalls/employeesApi"
import { getAllBranches } from "../../Helpers/apiCalls/Manage/Branches"
import { searchTerminal } from "../../Helpers/apiCalls/Manage/terminals"
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination"
import Footer from "../../Components/Footer/Footer"

export default function Users() {
  const { Dragger } = Upload
  const { id } = useParams()
  const [inactive, setInactive] = useState(false)
  const [option, setOption] = useState("Select")
  const [isClicked, setIsClicked] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [usersData, setUsersData] = useState([])
  const [employeeOptions, setEmployeeOptions] = useState([])
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)
  const [userData, setUserData] = useState({
    branch_id: "",
    terminal_id: "",
  })
  const [allData, setAllData] = useState([])
  const [terminals, setTerminals] = useState([])
  const [selectedID, setSelectedID] = useState("")
  const [employeeValue, setEmployeeValue] = useState({
    name: "first_name",
    label: "",
    value: "",
  })
  const [branchValue, setBranchValue] = useState({
    name: "buyer_branch_id",
    label: "",
    value: "",
  })
  const [filterConfig, setFilterConfig] = useState({
    tab: "office",
    type: "office",
    page: 1,
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)

  // VIEW
  const [showViewUserModal, setShowViewUserModal] = useState(false)
  const handleShowViewUserModal = () => setShowViewUserModal(true)
  const handleCloseViewUserModal = () => setShowViewUserModal(false)

  // EDIT
  const [showEditUserModal, setShowEditUserModal] = useState(false)
  const handleShowEditUserModal = () => setShowEditUserModal(true)
  const handleCloseEditUserModal = () => {
    setEmployeeValue({})
    setShowEditUserModal(false)
  }

  // ADD
  const [showAddUserModal, setShowAddUserModal] = useState(false)
  function handleShowAddUserModal(type) {
    setShowAddUserModal(true)
    if (type === "cashier") {
      // TO SET TYPE TO CASHIER AUTOMATICALLY
      setUserData({
        type: "cashier",
      })
    } else {
      setUserData({})
    }
  }
  const handleCloseAddUserModal = () => setShowAddUserModal(false)

  //API
  const handleTabSelect = (tabKey) => {
    setFilterConfig((prev) => {
      return {
        ...prev,
        branch_id: "",
        // type: "",
        tab: tabKey,
        type: tabKey,
      }
    })
  }
  const [shop, setShop] = useState("")
  const isInitialMount = useRef(true)
  const filterConfigKey = "manage-users-filterConfig"

  const [addTo, setAddTo] = useState("")
  const handleAddSelect = (e) => {
    setAddTo(e)
  }

  //REQUIRED ERROR HANDLING
  const [isError, setIsError] = useState({
    first_name: false,
    middle_name: false,
    last_name: false,
    email: false,
    type: false,
    username: false,
    confirm_password: false,
  })
  const [employeesData, setEmployeesData] = useState([])
  const [branches, setBranches] = useState([])
  const [allBranches, setAllBranches] = useState([])

  //ONCHANGE
  //ADD or CREATE USER
  const handleAddChange = (e) => {
    const { name, value } = e.target
    if (name === "type") {
      if (value !== "branch_oic" && value !== "branch_inventory_officer") {
        setUserData((prevState) => ({
          ...prevState,
          [name]: value,
          branch_id: "",
          branch_id_value: {},
        }))
      } else {
        setUserData((prevState) => ({
          ...prevState,
          [name]: value,
        }))
      }
    } else {
      setUserData((prevState) => ({
        ...prevState,
        [name]: value,
      }))
    }
  }

  //ADD or CREATE USER
  const handleAddNameChange = (e) => {
    const { name, value } = e
    if (e.var_name === "first_name") {
      setEmployeeValue({ name: e.var_name, label: e.label, value: e.value })
      setUserData({
        ...userData,
        employee_id: e.value,
        first_name: e.first_name,
        middle_name: e.middle_name,
        last_name: e.last_name,
      })
    } else if (e.var_name === "terminal_id") {
      setUserData({
        ...userData,
        terminal_id: e.id,
        branch_id: e.branch_id,
        first_name: e.branch_name,
        type: "terminal",
        [e.for]: {
          label: e.label,
          value: e.value,
        },
      })
    } else if (e.var_name === "branch_id") {
      setUserData({
        ...userData,
        branch_id: e.value,
        [e.for]: {
          label: e.label,
          value: e.value,
        },
      })
    }
  }

  //onEdit
  function handleOnEdit() {
    handleCloseViewUserModal()
    handleShowEditUserModal()
  }

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  //DELETE or REMOVE USER
  function handleDeleteUser() {
    removeUser(selectedID)
  }

  //API CALL
  async function fetchAllEmployees() {
    const response = await getAllEmployees()
    if (response.data.data) {
      var employeesList = response.data.data.map((employee) => {
        var info = {}

        info.var_name = "first_name"
        info.label = employee.first_name + " " + employee.last_name
        info.value = employee.id
        info.first_name = employee.first_name
        info.last_name = employee.last_name
        info.middle_name = employee.middle_name
        info.full_name =
          employee.first_name +
          " " +
          employee.middle_name +
          " " +
          employee.last_name
        return info
      })
      setEmployeeOptions(employeesList)
    } else {
      setEmployeesData([])
    }
  }

  async function fetchBranches() {
    setBranches([])
    const response = await getAllBranches()
    if (response.data) {
      var filteredBranches = response.data.data.data
        .filter((data) => {
          return data.is_franchise === "0"
        })
        .map((data) => {
          var branch = data
          branch.label = data.name
          branch.value = data.id
          branch.var_name = "branch_id"
          branch.for = "branch_id_value"
          return branch
        })
      setBranches(filteredBranches)

      var allBranches = response.data.data.data
        .filter((data) => {
          return data.is_franchise === "0"
        })
        .map((data) => {
          var branch = data
          branch.label = data.name
          branch.value = data.id
          branch.for = "branch_id_value"
          return branch
        })
      setAllBranches([{ label: "All Branches", value: "" }, ...allBranches])
    }
  }

  //DROPDOWN
  function handleSelectChange(e, row) {
    fetchUser(row.id)
    setSelectedID(row.id)
    if (e.target.value === "delete-user") {
      handleShowDeleteModal()
    } else if (e.target.value === "edit-user") {
      handleShowEditUserModal()
    } else if (e.target.value === "view-user") {
      handleShowViewUserModal()
    } else {
      refreshPage()
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-user" className="color-options">
          View
        </option>
        {isAdmin && (
          <option value="edit-user" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="delete-user" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    )
  }

  //API CALL
  async function fetchData() {
    setShowLoader(true)
    setAllData([])
    setTotalItems(0)
    const response = await searchUser(filterConfig)
    if (response.data) {
      let result = []
      result = response.data.data.map((data) => {
        var info = data
        info.full_name = data.first_name + " " + data.last_name
        return info
      })
      setAllData(result)
      setTotalItems(response.data.size)
    }
    setShowLoader(false)
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    const newTotalItems = Math.min(page * itemsPerPage, allData.length)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
    setTotalItems(newTotalItems)
  }

  // const handlePageChange = page => {
  //   setCurrentPage(page);
  //   setFilterConfig((prev) => {
  //     return {
  //       ...prev,
  //       page: page,
  //     };
  //   });
  // };

  async function fetchTerminals() {
    setShowLoader(true)
    setTerminals([])
    const response = await searchTerminal(filterConfig)
    if (response.data) {
      let result = response.data.data.data
        .filter((data) => {
          return data.has_account === "0"
        })
        .map((data) => {
          var info = data
          info.label = data.name
          info.value = data.id
          info.branch_id = data.branch_id
          info.branch_name = data.branch_name
          info.for = "terminal_id_value"
          info.var_name = "terminal_id"
          return info
        })
      setTerminals(result)
    }
    setShowLoader(false)
  }

  async function fetchUser(id) {
    setUserData([])
    const response = await getSingleUser(id)
    if (response.data) {
      var user = response.data[0]
      user.password = ""
      if (user.middle_name !== null) {
        user["full_name"] =
          user.first_name + " " + user.middle_name + " " + user.last_name
      } else {
        user["full_name"] = user.first_name + " " + user.last_name
      }
      user.terminal_id_value = {
        label: user.terminal_name,
        value: user.terminal_id,
      }
      user.branch_id_value = {
        label: user.branch_name,
        value: user.branch_id,
      }
      setUserData(user)
      setPrevAttachments(user.attachments)
      if (user.employee_id !== null) {
        setEmployeeValue({
          name: "first_name",
          label: user.employee_name,
          value: user.employee_id,
        })
      }
    } else {
      setUserData({})
    }
  }

  async function handleSaveUser() {
    if (validateUsers(userData, setIsError, addTo)) {
      setIsClicked(true)
      if (userData.password === userData.confirm_password) {
        userData.attachments = fileList
        const response = await createUser(userData, "")
        if (response.data) {
          toast.success(response.data.message, {
            style: toastStyle(),
          })
          handleCloseAddUserModal()
          setFileList([])
          // refreshPage();
          fetchData()
        } else if (response.error) {
          response.error?.response?.data?.messages.map((data) => {
            return toast.error(data)
          })
          setTimeout(() => {
            // refreshPage();
          }, 1000)
        }
      } else {
        toast.error("Password does not match!", {
          style: toastStyle(),
        })
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
  }

  async function handleEditUser() {
    if (validateUsers(userData, setIsError, addTo)) {
      setIsClicked(true)
      userData.attachments = fileList
      userData.prev_files = prevAttachments
      const response = await editUser(userData)

      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        handleCloseEditUserModal()
        // fetchData();
        refreshPage()
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setTimeout(() => {
          refreshPage()
        }, 1000)
      }
      setIsClicked(false)
    } else {
      toast.error("Please fill in all fields!", { style: toastStyle() })
    }
  }

  async function removeUser(id) {
    setIsClicked(true)
    const response = await deleteUser(id)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      setTimeout(() => {
        refreshPage()
      }, 1000)
    } else {
      response.error?.response?.data?.messages.map((data) => {
        return toast.error(data)
      })
      setTimeout(() => {
        refreshPage()
      }, 1000)
    }
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (prevAttachments.length === 0) {
      if (file.size > 2000000) {
        setShowFileExceedModal(true)
      } else {
        //COMPRESSING FILE
        new Compressor(file, {
          quality: 0.6,
          success: (compressedResult) => {
            setFileList([compressedResult])
          },
        })
      }
      return false
    } else {
      toast.error(
        "User already have a signature attached, please delete the file attached before uploading"
      )
    }
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  useEffect(() => {
    fetchAllEmployees()
    fetchBranches()
    fetchTerminals()
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  return (
    <div>
      <Toaster position="top-right" reverseOrder={false} />
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              USERS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              class="search-bar"
              name="name"
              placeholder="Search name..."
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") && handleOnSearch(e)
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <DropdownButton
                as={ButtonGroup}
                title="Add"
                id="bg-nested-dropdown"
                className="add-btn"
                onSelect={handleAddSelect}
              >
                <Dropdown.Item
                  eventKey="office"
                  onClick={() => handleShowAddUserModal("office")}
                >
                  Office
                </Dropdown.Item>
                {/* <Dropdown.Item eventKey="terminal" onClick={() => handleShowAddUserModal("terminal")}>
                      Terminal
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="cashier" onClick={() => handleShowAddUserModal("cashier")}>
                      Cashier
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="branch" onClick={handleShowAddUserModal}>
                      Branch
                    </Dropdown.Item> */}
              </DropdownButton>
            </div>
          </Col>
        </Row>

        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={"office"}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="office" title="Office">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                  <Form.Select
                    name="type"
                    className="date-filter force-width w-full"
                    onChange={(e) => handleOnSearch(e)}
                  >
                    <option value="" hidden selected className="text-uppercase">
                      Role
                    </option>
                    <option value="">All</option>
                    <option value="admin">Admin</option>
                    {/* <option value="bidding_officer">Bidding Officer</option>
                    <option value="purchasing_officer">Purchasing Officer</option>
                    <option value="warehouse_manager">Warehouse Manager</option>
                    <option value="warehouse_assistant">Warehouse Assistant</option>
                    <option value="branch_oic">Branch OIC</option>
                    <option value="branch_inventory_officer">Branch Inventory Officer</option>
                    <option value="cashier">Cashier</option>
                    <option value="wholesale_head">Wholesale Head</option>
                    <option value="wholesale_assistant">Wholesale Assistant</option>
                    <option value="account_officer">Account Officer</option>
                    <option value="collection_officer">Collection Officer</option>
                    <option value="hr_officer">HR Officer</option> */}
                  </Form.Select>
                </Col>
              </Row>
              <div className="mb-2" />
              <ManageTableWithDynamicPagination
                tableHeaders={["FULL NAME", "USERNAME", "ROLE", "ACTIONS"]}
                headerSelector={["full_name", "username", "type"]}
                tableData={allData}
                ActionBtn={(row) => ActionBtn(row)}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab>
          {/* <Tab eventKey="terminal" title="terminal">
            <div className="tab-content">
              <div className="mb-3" />
              <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                  Filter By:
              </span>
              <Row className="PO-filters flex flex-row mx-2 my-1">
                <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                    className="dropsearch-filter px-0 py-0 me-2"
                    classNamePrefix="react-select"
                    placeholder="Select Branch"
                    styles={selectDropdownStyle}
                    options={allBranches}
                    onChange={(e) => {
                    setFilterConfig((prev) => {
                        return { ...prev, branch_id: e.value };
                    });
                    }}
                  />
                </Col>
              </Row>
              <div className="mb-2" />
              <ManageTableWithDynamicPagination
                tableHeaders={["FULL NAME", "USERNAME", "ROLE", "ACTIONS"]}
                headerSelector={["full_name", "username", "type"]}
                tableData={allData}
                ActionBtn={(row) => ActionBtn(row)}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab> */}
          {/* <Tab eventKey="cashier" title="cashier">
            <div className="tab-content">
              <ManageTableWithDynamicPagination
                tableHeaders={["FULL NAME", "USERNAME", "ROLE", "ACTIONS"]}
                headerSelector={["full_name", "username", "type"]}
                tableData={allData}
                ActionBtn={(row) => ActionBtn(row)}
                showLoader={showLoader}
                // used in dynamic pagination
                totalItems={totalItems}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </Tab> */}
        </Tabs>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="user"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={handleDeleteUser}
        isClicked={isClicked}
      />
      <AddModal
        title="USER"
        type="user"
        show={showAddUserModal}
        onHide={handleCloseAddUserModal}
        onSave={handleSaveUser}
        isClicked={isClicked}
      >
        <div className="mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            {(addTo === "office" || addTo === "cashier") && (
              <Col xs={12} lg={3}>
                SELECT EMPLOYEE
                <span className="required"> * </span>
                <Select
                  name="first_name"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Dispatcher..."
                  value={employeeValue}
                  options={employeeOptions}
                  onChange={(e) => handleAddNameChange(e)}
                />
              </Col>
            )}
            {addTo === "terminal" && (
              <>
                <Col xs={12} lg={3}>
                  Select Terminal
                  <span className="required"> * </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select terminal..."
                    value={userData.terminal_id_value}
                    options={terminals}
                    onChange={(e) => handleAddNameChange(e)}
                  />
                  <InputError
                    isValid={isError.terminal_id}
                    message={"Terminal is required"}
                  />
                </Col>
                <Col>
                  BRANCH NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="first_name"
                    className="nc-modal-custom-input"
                    value={userData.first_name}
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.branch_id}
                    message={"Branch is required"}
                  />
                </Col>
              </>
            )}
            {(addTo === "office" || addTo === "cashier") && (
              <>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  FIRST NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="first_name"
                    className="nc-modal-custom-input"
                    value={userData.first_name}
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.first_name}
                    message={"First name is required"}
                  />
                </Col>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  LAST NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="last_name"
                    value={userData.last_name}
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.last_name}
                    message={"Last name is required"}
                  />
                </Col>
                <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                  MIDDLE NAME
                  <Form.Control
                    type="text"
                    name="middle_name"
                    value={userData.middle_name}
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={1} className="mt-2 mt-lg-0">
                  SUFFIX
                  <Form.Control
                    type="text"
                    name="suffix"
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
              </>
            )}
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              USERNAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="username"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.username}
                message={"Username is required"}
              />
            </Col>
            {(addTo === "office" || addTo === "cashier") && (
              <>
                <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                  TYPE
                  <span className="required"> * </span>
                  <select
                    name="type"
                    className="nc-modal-custom-select"
                    value={userData.type}
                    onChange={(e) => handleAddChange(e)}
                    required
                  >
                    <option selected hidden>
                      Select
                    </option>
                    <option value="admin">Admin</option>
                    {/* <option value="bidding_officer">Bidding Officer</option>
                    <option value="purchasing_officer">Purchasing Officer</option>
                    <option value="warehouse_manager">Warehouse Manager</option>
                    <option value="warehouse_assistant">Warehouse Assistant</option>
                    <option value="branch_oic">Branch OIC</option>
                    <option value="branch_inventory_officer">Branch Inventory Officer</option>
                    <option value="cashier">Cashier</option>
                    <option value="wholesale_head">Wholesale Head</option>
                    <option value="wholesale_assistant">Wholesale Assistant</option>
                    <option value="account_officer">Account Officer</option>
                    <option value="collection_officer">Collection Officer</option>
                    <option value="hr_officer">HR Officer</option> */}
                  </select>
                  <InputError
                    isValid={isError.type}
                    message={"User Type is required"}
                  />
                </Col>
                {(userData.type === "branch_oic" ||
                  userData.type === "branch_inventory_officer") && (
                  <>
                    <Col>
                      Select Branch
                      <span className="required"> * </span>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select branch..."
                        value={userData.branch_id_value}
                        options={branches}
                        onChange={(e) => handleAddNameChange(e)}
                      />
                    </Col>
                  </>
                )}
              </>
            )}
            {addTo === "terminal" && (
              <Col>
                TYPE
                <span className="required"> * </span>
                <Form.Control
                  type="text"
                  name="type"
                  className="nc-modal-custom-input"
                  value={userData.type}
                  onChange={(e) => handleAddChange(e)}
                  required
                />
                <InputError
                  isValid={isError.type}
                  message={"User Type is required"}
                />
              </Col>
            )}
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              EMAIL
              <Form.Control
                type="email"
                name="email"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PASSWORD
              <span className="required"> * </span>
              <Form.Control
                type="password"
                name="password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Password is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONFIRM PASSWORD
              <Form.Control
                type="password"
                name="confirm_password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Confirm Password is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>
        </div>
      </AddModal>
      <EditModal
        title="USER"
        type="user"
        show={showEditUserModal}
        onHide={handleCloseEditUserModal}
        onSave={handleEditUser}
        isClicked={isClicked}
      >
        <div className="mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            {(filterConfig.tab === "office" ||
              filterConfig.tab === "cashier") && (
              <Col xs={12} lg={3}>
                SELECT EMPLOYEE
                <span className="required"> * </span>
                <Select
                  name="first_name"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Dispatcher..."
                  value={employeeValue}
                  options={employeeOptions}
                  onChange={(e) => handleAddNameChange(e)}
                />
              </Col>
            )}
            {filterConfig.tab === "terminal" && (
              <>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  Select Terminal
                  <span className="required"> * </span>
                  <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select terminal..."
                    value={userData.terminal_id_value}
                    options={terminals}
                    onChange={(e) => handleAddNameChange(e)}
                  />
                </Col>
                <Col>
                  BRANCH NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="first_name"
                    className="nc-modal-custom-input"
                    value={userData.first_name}
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
              </>
            )}
            {(filterConfig.tab === "office" ||
              filterConfig.tab === "cashier") && (
              <>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  FIRST NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="first_name"
                    className="nc-modal-custom-input"
                    value={userData.first_name}
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.first_name}
                    message={"First name is required"}
                  />
                </Col>
                <Col xs={12} lg={3} className="mt-2 mt-lg-0">
                  LAST NAME
                  <span className="required"> * </span>
                  <Form.Control
                    type="text"
                    name="last_name"
                    value={userData.last_name}
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                  <InputError
                    isValid={isError.last_name}
                    message={"Last name is required"}
                  />
                </Col>
                <Col xs={12} lg={2} className="mt-2 mt-lg-0">
                  MIDDLE NAME
                  <Form.Control
                    type="text"
                    name="middle_name"
                    value={userData.middle_name}
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
                <Col xs={12} lg={1} className="mt-2 mt-lg-0">
                  SUFFIX
                  <Form.Control
                    type="text"
                    name="suffix"
                    className="nc-modal-custom-input"
                    onChange={(e) => handleAddChange(e)}
                    required
                  />
                </Col>
              </>
            )}
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={6}>
              USERNAME
              <span className="required"> * </span>
              <Form.Control
                type="text"
                name="username"
                value={userData.username}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.username}
                message={"Username is required"}
              />
            </Col>
            {(filterConfig.tab === "office" ||
              filterConfig.tab === "cashier") && (
              <>
                <Col xs={12} lg={6} className="mt-2 mt-lg-0">
                  TYPE
                  <span className="required"> * </span>
                  <select
                    name="type"
                    className="nc-modal-custom-select"
                    value={userData.type}
                    onChange={(e) => handleAddChange(e)}
                    required
                  >
                    <option selected hidden>
                      Select
                    </option>
                    <option value="admin">Admin</option>
                    {/* <option value="bidding_officer">Bidding Officer</option>
                    <option value="purchasing_officer">Purchasing Officer</option>
                    <option value="warehouse_manager">Warehouse Manager</option>
                    <option value="warehouse_assistant">Warehouse Assistant</option>
                    <option value="branch_oic">Branch OIC</option>
                    <option value="branch_inventory_officer">Branch Inventory Officer</option>
                    <option value="cashier">Cashier</option>
                    <option value="wholesale_head">Wholesale Head</option>
                    <option value="wholesale_assistant">Wholesale Assistant</option>
                    <option value="account_officer">Account Officer</option>
                    <option value="collection_officer">Collection Officer</option>
                    <option value="hr_officer">HR Officer</option> */}
                  </select>
                  <InputError
                    isValid={isError.type}
                    message={"User Type is required"}
                  />
                </Col>
                {(userData.type === "branch_oic" ||
                  userData.type === "branch_inventory_officer") && (
                  <>
                    <Col>
                      Select Branch
                      <span className="required"> * </span>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder="Select branch..."
                        value={userData.branch_id_value}
                        options={branches}
                        onChange={(e) => handleAddNameChange(e)}
                      />
                    </Col>
                  </>
                )}
              </>
            )}
            {filterConfig.tab === "terminal" && (
              <Col>
                TYPE
                <span className="required"> * </span>
                <Form.Control
                  type="text"
                  name="type"
                  className="nc-modal-custom-input"
                  value={userData.type}
                  onChange={(e) => handleAddChange(e)}
                  required
                />
              </Col>
            )}
          </Row>
          <Row className="nc-modal-custom-row">
            <Col xs={12} lg={4}>
              EMAIL
              <Form.Control
                type="email"
                name="email"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              PASSWORD
              <span className="required"> * </span>
              <Form.Control
                type="password"
                name="password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Password is required"}
              />
            </Col>
            <Col xs={12} lg={4} className="mt-2 mt-lg-0">
              CONFIRM PASSWORD
              <Form.Control
                type="password"
                name="confirm_password"
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.confirm_password}
                message={"Confirm Password is required"}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>
              <span className="required"> * </span>
              <span className="required"> required fields </span>
            </Col>
          </Row>
          <div className="mt-4 noPrint mx-3">
            <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
            <Row className="">
              {prevAttachments &&
                prevAttachments.map((attachment) => (
                  <Col
                    xs={1}
                    onClick={() => {
                      setPreviewFile(attachment.file_url)
                      setPreview(true)
                    }}
                    className="cursor-pointer preview-container"
                  >
                    <img src={attachment.file_url} className="img-preview" />
                  </Col>
                ))}
              {!prevAttachments ||
                (prevAttachments.length === 0 && (
                  <Col xs={1}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>
        </div>
      </EditModal>
      <ViewModal
        withButtons
        show={showViewUserModal}
        onHide={handleCloseViewUserModal}
        onEdit={handleOnEdit}
      >
        <div>
          <div className="col-sm-12 space">
            <span className="custom-modal-body-title-user-details">
              USER DETAILS
            </span>
            <div className="mt-3 container-wrapper">
              <Row className="nc-modal-custom-row-view">
                <Col xs={6} lg={3} className="nc-modal-custom-row-details">
                  FULL NAME
                  <Row className="nc-modal-custom-row">
                    <Col> {userData.full_name} </Col>
                  </Row>
                </Col>
                <Col
                  xs={6}
                  lg={3}
                  className="mt-2 mt-lg-0 nc-modal-custom-row-details"
                >
                  USERNAME
                  <Row className="nc-modal-custom-row">
                    <Col> {userData.username} </Col>
                  </Row>
                </Col>
                <Col
                  xs={8}
                  lg={3}
                  className="mt-2 mt-lg-0 nc-modal-custom-row-details"
                >
                  EMAIL
                  <Row className="nc-modal-custom-row">
                    <Col> {userData.length !== 0 ? userData.email : null} </Col>
                  </Row>
                </Col>
                <Col
                  xs={4}
                  lg={3}
                  className="mt-2 mt-lg-0 nc-modal-custom-row-details"
                >
                  ROLE
                  <Row className="nc-modal-custom-row">
                    <Col> {userData.type} </Col>
                  </Row>
                </Col>
              </Row>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </div>
          </div>
        </div>
      </ViewModal>
      <Modal
        zIndex={1100}
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="example"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
      <Footer />
    </div>
  )
}
